/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */

/*
* Action type for actions to be processed by our custom fetch middleware
*/
export const FETCH_ACTION = 'FETCH_ACTION';

/**
 * App initiates a complex promise-based action that manages sign in and dispatches
 * SIGN_IN_USER_REQUEST and SIGN_IN_USER_RESPONSE actions
 */
export const SIGN_IN_USER = 'SIGN_IN_USER';

/**
 * App requests user auth token
 */
export const SIGN_IN_USER_REQUEST = 'SIGN_IN_USER_REQUEST';

/**
 * App receives response to request for user auth token
 */
export const SIGN_IN_USER_RESPONSE = 'SIGN_IN_USER_RESPONSE';

/**
 * Destroy the user auth token
 */
export const SIGN_OUT_USER = 'SIGN_OUT_USER';

/**
 * App initiates a complex promise-based action that manages sign in and dispatches
 * CREATE_USER_PASSWORD_REQUEST and CREATE_USER_PASSWORD_RESPONSE
 */

export const CREATE_USER_PASSWORD = 'CREATE_USER_PASSWORD';

/**
 * App requests a user password be created
 */
export const CREATE_USER_PASSWORD_REQUEST = 'CREATE_USER_PASSWORD_REQUEST';

/**
 * App receives response to request that a user password be created
 */

export const CREATE_USER_PASSWORD_RESPONSE = 'CREATE_USER_PASSWORD_RESPONSE';

/**
 * App requests inventories for a given org
 */

export const FETCH_INVENTORIES_REQUEST = 'FETCH_INVENTORIES_REQUEST';

/**
 * App receives response to request for the inventories for a given org
 */

export const FETCH_INVENTORIES_RESPONSE = 'FETCH_INVENTORIES_RESPONSE';

/**
 * App requests an inventory by id
 */

export const FETCH_INVENTORY_REQUEST = 'FETCH_INVENTORY_REQUEST';

/**
 * App receives response to request for an inventory
 */

export const FETCH_INVENTORY_RESPONSE = 'FETCH_INVENTORY_RESPONSE';

/**
 * App requests user data from api
 */
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';

/**
 * App receives user data from api
 */
export const FETCH_USER_RESPONSE = 'FETCH_USER_RESPONSE';

/**
 * App requests that an organization be created
 */
export const CREATE_ORGANIZATION_REQUEST = 'CREATE_ORGANIZATION_REQUEST';

/**
 * App receives response for request for an organization to be created
 */
export const CREATE_ORGANIZATION_RESPONSE = 'CREATE_ORGANIZATION_RESPONSE';

/**
 * App requests that a user be created
 */
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';

/**
 * App receives response for request for an user to be created
 */
export const CREATE_USER_RESPONSE = 'CREATE_USER_RESPONSE';

/**
 * App requests that an organization be updated
 */
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';

/**
 * App receives response for request for an organization to be updated
 */
export const UPDATE_USER_RESPONSE = 'UPDATE_USER_RESPONSE';

/**
 * App requests an organization
 */
export const FETCH_ORGANIZATION_REQUEST = 'FETCH_ORGANIZATION_REQUEST';

/**
 * App receives response for request for an organization
 */
export const FETCH_ORGANIZATION_RESPONSE = 'FETCH_ORGANIZATION_RESPONSE';

/**
 * App requests that an organization be created
 */
export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST';

/**
 * App receives response for request for an organization to be created
 */
export const UPDATE_ORGANIZATION_RESPONSE = 'UPDATE_ORGANIZATION_RESPONSE';

/**
 * App requests organizations for the admin area
 */

export const FETCH_ORGANIZATIONS_REQUEST = 'FETCH_ORGANIZATIONS_REQUEST';

/**
 * App receives responses organizations for the admin area
 */
export const FETCH_ORGANIZATIONS_RESPONSE = 'FETCH_ORGANIZATIONS_RESPONSE';

/**
 * App requests users for the admin area
 */

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';

/**
 * App receives responses users for the admin area
 */
export const FETCH_USERS_RESPONSE = 'FETCH_USERS_RESPONSE';



// WEBPACK FOOTER //
// ./js/constants/actionTypes.js